
import { Rules } from "./Rules";
import { OriginStory } from "./OriginStory";
import { GameHeader } from "./GameHeader";
import { Button } from "../ui/button";
import { useState, useEffect } from "react";
import { WelcomeVideoModal } from "./WelcomeVideoModal";

interface StartGameContentProps {
  onStart: () => void;
  hasCompletedToday: boolean;
}

export function StartGameContent({
  onStart,
  hasCompletedToday
}: StartGameContentProps) {
  const [showVideo, setShowVideo] = useState(false);
  
  // Extract YouTube video ID from the full URL
  const youtubeVideoId = "lEZemROzYhA";
  
  // Check if this is the first visit
  useEffect(() => {
    const hasSeenWelcomeVideo = localStorage.getItem("has_seen_welcome_video");
    
    if (!hasSeenWelcomeVideo) {
      setShowVideo(true);
    }
  }, []);
  
  const handleVideoClose = () => {
    setShowVideo(false);
    localStorage.setItem("has_seen_welcome_video", "true");
  };
  
  const handleStartClick = () => {
    console.log('Start game button clicked in StartGameContent');
    // Add more debug info
    console.log('hasCompletedToday:', hasCompletedToday);
    // Call onStart and ensure proper event propagation
    onStart();
  };
  
  return (
    <div className="h-full w-full min-w-[320px] flex flex-col items-center py-2">
      <div className="container mx-auto px-4 py-4 flex flex-col items-center">
        <GameHeader />
      </div>
        
      <div className="w-full animate-fade-in px-4 flex flex-col items-center justify-center">
        <div className="text-center text-black mb-6 mt-1 space-y-0.5 font-['Times_New_Roman']">
          <p className="text-lg font-medium leading-none">choose your logic.</p>
          <p className="text-lg font-medium leading-none">set your order.</p>
          <p className="text-lg font-medium leading-none">lock in.</p>
          <p className="text-lg font-medium leading-none">match to win!</p>
        </div>
        
        <Button 
          onClick={handleStartClick} 
          className="w-full max-w-xs px-8 py-4 bg-black text-white rounded-lg font-medium hover:opacity-90 transition-opacity whitespace-nowrap flex items-center justify-center text-2xl mb-4"
          type="button"
          disabled={hasCompletedToday}
          variant="default"
          size="lg"
        >
          Start Game
        </Button>
        
        <div className="flex w-full max-w-xs gap-4">
          <div className="w-1/2">
            <Rules />
          </div>
          <div className="w-1/2">
            <OriginStory />
          </div>
        </div>
        
        <div className="text-center text-gray-500 text-sm mt-6">
          <p className="mb-0.5">Created by:</p>
          <a href="https://matchmylogic.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 underline">
            matchmylogic.com
          </a>
        </div>
        
        {/* Welcome Video Modal */}
        <WelcomeVideoModal 
          videoId={youtubeVideoId} 
          open={showVideo} 
          onClose={handleVideoClose} 
        />
      </div>
    </div>
  );
}
